<template>
    <router-link to="/test" :active-class="activeClass" :exact-active-class="exactActiveClass">
        <slot></slot>
    </router-link>
</template>
<script>
export default {
    props: ['href', 'activeClass', 'exactActiveClass'],
}
</script>
